import React, { useCallback } from 'react';
import {Col, Form, Row} from "antd";
import {t, Trans} from "@lingui/macro";
import PublicCurrencySelect from "../../Select/PublicCurrency";
import ToggleToEdit from "../../ToggleToEdit";
import {connect} from "react-redux";
import PublicListActions from "bukku/redux/PublicList/actions";

const { readPublicCurrenciesList } = PublicListActions;

export const CurrencyFormItem = connect(null, { readPublicCurrenciesList })(props => {
    const { readPublicCurrenciesList, size, keepOpenAfterToggle, onToggleOpen } = props;

    const renderNotToggled = useCallback(toggleOpen => (
        <Row type="flex">
            <Col span={24} style={{fontSize: 13}}>
                <Trans>
                    {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                    Home currency is set to <strong>MYR</strong>.
                </Trans>
                &nbsp;
                <span
                    className="link"
                    onClick={() => {
                        toggleOpen();
                        readPublicCurrenciesList();
                    }}
                >
                    <Trans>Change</Trans>
                </span>
                <Form.Item name="currency_code" initialValue="MYR" noStyle>
                    <span />
                </Form.Item>
            </Col>
        </Row>
    ), [readPublicCurrenciesList]);

    const formItem = (
        <Row type="flex">
            <Col span={24}>
                <Form.Item
                    name="currency_code"
                    label={t`Home Currency`}
                    rules={[{
                        required: true,
                        message: t`Currency is required.`,
                    }]}
                    initialValue="MYR"
                >
                    <PublicCurrencySelect popupContainerId="parentElement" size={size || 'medium'} />
                </Form.Item>
            </Col>
        </Row>
    );

    // used in partner create client modal, to keep the form item in edit mode
    if (keepOpenAfterToggle)
        return formItem;

    return (
        <ToggleToEdit renderNotToggled={renderNotToggled} onToggleOpen={onToggleOpen}>
            {formItem}
        </ToggleToEdit>
    );
});
